import { DB_MODULE } from '../constants';

const GLOBAL_ASSIGNMENT_ROLES = ['it-admin', 'application-admin'];

export const canManageEmployeeAssignments = (roles = [], module = null) => {
  const roleNames = roles
    .map((role) => typeof role === 'string' ? role : role?.name)
    .filter(Boolean);

  if (GLOBAL_ASSIGNMENT_ROLES.some((role) => roleNames.includes(role))) {
    return true;
  }

  const moduleAdministratorRole = module === DB_MODULE
    ? 'module-admin-db'
    : 'module-admin-lob';

  return roleNames.includes(moduleAdministratorRole);
};
